module.exports = __webpack_public_path__ + "img/nuc8-i3cysm-i3cysn-front-angle-rwd.png.rendition.intel.web.480.270.bcdd1ae3.png";